/**
 * Method by which short positions are assigned to an exercise notice during exercise and assignment processing
 * tag: 744
 * @readonly
 * @enum {string} (char)
 */
export enum AssignmentMethod {
  /** Pro rata */
  ProRata = 'P',
  /** Random */
  Random = 'R',
}
